import { AccountProductSettingsService } from '@/modules/global-settings/onboarder/services/account-product-settings.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
// Create a new instance of the AccountProductSettingsService class
const accountProductService = new AccountProductSettingsService();
export const state = {
  accountProductSettings: []
};
// Define the mutations of the AccountProductSettings module
export const mutations = {
  ...make.mutations(state)
};
// Define the actions of the AccountProductSettings module
export const getters = {
  ...make.getters(state),
  activeProductSettings(state) {
    return state.accountProductSettings.filter((a) => a.status == true);
  }
};
// Define the actions of the AccountProductSettings module
export const actions = {
  /**
   * Fetch account product settings
   * @param {Object} object - Vuex context
   * @returns {Array} Array of account product settings
   * @private This will set the values in state after fetching
   */
  getProducts: async ({ commit }) => {
    try {
      const { data } = await accountProductService.getProducts();
      commit('SET_ACCOUNT_PRODUCT_SETTINGS', data);
      return data;
    } catch (error) {
      Logger.error('getting account product settings');
      throw error;
    }
  },
  /**
   * Create account product settings
   * @param {Object} object - Vuex context
   * @param {Object} payload - Payload to create account product settings
   * @returns {Array} Array of account product settings
   * @private This will re-fetch the account product settings after creating
   */
  createProducts: async ({ dispatch }, payload) => {
    try {
      const { data } = await accountProductService.createProduct(payload);
      dispatch('getProducts');
      return data;
    } catch (error) {
      Logger.error('creating account product settings');
      throw error;
    }
  },
  /**
   * Update account product settings
   * @param {Object} object - Vuex context
   * @param {Object} payload - Payload to update account product settings
   * @param {String} payload.id - Id of the account product settings to update
   * @param {Object} payload.payload - Payload to update account product settings
   * @returns {void}
   * @private This will re-fetch the account product settings after updating
   */
  updateProduct: async ({ dispatch }, { id, payload }) => {
    try {
      await accountProductService.updateProduct(id, payload);
      dispatch('getProducts');
    } catch (error) {
      Logger.error('updating account product settings');
      throw error;
    }
  }
};
